import {
  validateString as validateStringOpds,
  validateEmail,
  validateDigits,
} from '@op/opds.validate';

import {
  STRING_MAX_LENGTH,
} from '../../../constants/common';

//export const ValidationResult;
export class ErrorCode extends Error {
  code;

  constructor(code) {
    super(code);
    this.code = code;
  }
}

export const validateYear = (input, limit) => {
  if (!input) {
    return new ErrorCode('error.fill.in.missing.information');
  }
  const valid = validateDigits(input.toString(), 4, 4, "");
  if (typeof valid === "string" && valid.length === input.length) {
    const year = parseInt(input);
    if ((year >= (limit || 1900)) && (year <= new Date().getFullYear())) {
      return input;
    }
  }
  return new ErrorCode('errorText.invalidInput');;
};

export const validateNumeric = (input, limit = 999999) => {
  const pattern = /^[1-9]\d*(?:\.\d{1,2})?$/;
  if (!input) {
    return new ErrorCode('error.fill.in.missing.information');
  }
  if (!pattern.test(input)) {
    return new ErrorCode('error.invalidCharacters');
  }
  if (input > limit || input < 1) {
    return new ErrorCode('errorText.invalidInput');
  }
  return input;
};

export const validateEmailwithTLD = (str) => {
  return validateEmail(str, { isTLDRequired: true });
};

export const validatePropertyCode = (input) => {
  const pattern = /^\d{1,3}-\d{1,3}-\d{1,4}-\d{1,4}$/;
  if (!input) {
    return new ErrorCode('error.fill.in.missing.information');
  }
  if (!pattern.test(input)) {
    return new ErrorCode('error.invalidCharacters');
  }
  return input;
};

export const validateSport = (str) => {
  const pattern = /^[\sa-zA-Z0-9åäöÅÄÖ.\u0023,?!()+-/&:"'@%€]+(\s[a-zA-Z0-9åäöÅÄÖ]+)*$/;
  if (pattern.test(str)) {
    return validateStringOpds(str, 1, STRING_MAX_LENGTH);
  }
  return new ErrorCode('error.invalidCharacters');
};

export const validateString = (str) => {
  const pattern = /^[a-zA-Z\u00C0-\u017F'´`]+([ |-][a-zA-Z\u00C0-\u017F'´`]+)*$|^$/;
  if (pattern.test(str)) {
    return validateStringOpds(str, 1, STRING_MAX_LENGTH);
  }
  return new ErrorCode('error.invalidCharacters');
};

export const validateStringwithoutSP = (str, limit = 1) => {
  const pattern = /^([0-9a-zA-Z\u00C0-\u017F]+([ |-][0-9a-zA-Z\u00C0-\u017F]+)*|)$/;
  if (pattern.test(str)) {
    return validateStringOpds(str, limit, STRING_MAX_LENGTH);
  }
  return new ErrorCode('error.invalidCharacters');
};

export const validateAlphaNumericInput = (str) => {
  const pattern = /(^[0-9a-zA-Z\u00C0-\u017F'´`]+([ |-][0-9a-zA-Z\u00C0-\u017F'´`]+)*$)|(^$)/;
  if (pattern.test(str)) {
    return validateStringOpds(str, 1, STRING_MAX_LENGTH);
  }
  return new ErrorCode('error.invalidCharacters');
};
